import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import './css/WelcomeMessage.css';
import JWTErrorPopup from './JWTErrorPopup'; // Import the popup component
import { handleJWTResponse } from './jwtErrorHandler'; 

function AccountsPage() {
    const [accounts, setAccounts] = useState([]);
    const [selectedAccountId, setSelectedAccountId] = useState(null);
    const [firmId, setFirmId] = useState('');
    const navigate = useNavigate();
    const location = useLocation();
    const { email } = location.state || {};
    const [showJWTError, setShowJWTError] = useState(false);
    const [jwtErrorMessage, setJwtErrorMessage] = useState('');

    const closeJWTErrorPopup = () => {
        setShowJWTError(false);
        navigate('/firm');
    };
    useEffect(() => {
        // if (!email) {
        //     navigate('/firm'); // Redirect back if email is missing
        //     return;
        // }

        fetch('https://cloud9requests.symphony.com/requests/api/getAccountsByEmail', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email }),
            credentials: 'include',
        })
            .then(response => handleJWTResponse(response, setJwtErrorMessage, setShowJWTError))
            .then(data => setAccounts(data.records))
            .catch(error => {
                if (error.message !== "JWT error handled") {
                    console.error('Error fetching accounts:', error);
                }
            });
    }, [email, navigate]);

    const handleAccountChange = (event) => {
        const account = accounts.find(acc => acc.Id === event.target.value);
        setSelectedAccountId(event.target.value);
       
        setFirmId(account ? account.Account__r.Firm_ID__c : '');
    };

    const selectedAccount = accounts.find(account =>account.Account_ID__c === selectedAccountId);

    const handleNext = () => {
        if (selectedAccountId) {
            navigate('/currencyPage', {
                state: {
                    firmId : selectedAccount.Account__r.Firm_ID__c,
                    firmName: selectedAccount.Account__r.Name,
                    accountId: selectedAccountId,
                    email   
                }
            });
        }
    };

    return (
        <div>
             {/* JWT Error Popup */}
             {showJWTError && (
                <JWTErrorPopup 
                    message={jwtErrorMessage} 
                    onClose={closeJWTErrorPopup} 
                />
            )}
            
            <Link to="/firm" className="back-link">Back</Link>
            <div className="opportunity-container" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <img src="https://cloud9requests.symphony.com/Cloud9_Logo.png" alt="C9 Logo" width="300" height="100" />
                <h2>Select a Cloud9 Firm</h2>
                <label>Select a Cloud9 Firm</label>
                <select value={selectedAccountId || ''} onChange={handleAccountChange}>
                    <option value="" disabled>Select an Account</option>
                    {accounts.map(account => (
                        <option key={account.Account_ID__c} value={account.Account_ID__c}>
                            {account.Account__r.Name}
                        </option>
                    ))}
                </select>
                {selectedAccount && (
                    <div style={{ marginTop: '20px' }}>
                        <h3>Account Details</h3>
                        <p><strong>Name:</strong> {selectedAccount.Name}</p>
                        <p><strong>Firm ID:</strong> {selectedAccount.Account__r.Firm_ID__c}</p>
                    </div>
                )}
                <button onClick={handleNext} disabled={!selectedAccountId}>Next</button>
            </div>
        </div>
    );
}

export default AccountsPage;
